import type { DocumentAssetUrls } from "./types";

/** Local object-URL previews keyed by freshly uploaded asset id. */
export type AssetUrlOverrides = Record<string, string>;

/**
 * Merges local blob-url overrides over server-resolved asset urls so a
 * freshly uploaded image previews before the document is saved and refetched.
 * @param assetUrls - Server-resolved signed urls from the saved document
 * @param overrides - Local object-urls for assets uploaded this session
 * @returns The merged urls, with overrides taking precedence
 */
export function mergeAssetUrls(
  assetUrls: DocumentAssetUrls,
  overrides: AssetUrlOverrides,
): DocumentAssetUrls {
  return { ...assetUrls, ...overrides };
}
